/**
 * Lazy Load Images
 *
 * NOTE: polyfill in /lib/Settings.php
 */

export default () => {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    let loadImage = function (lazyImage) {
        let picture = lazyImage.closest("picture");
        if (picture) {
            let sources = picture.querySelectorAll("source[data-srcset]");
            sources.forEach(function (source) {
                source.srcset = source.dataset.srcset;
            });
        }
        // Native loading="lazy" (WordPress 6.7+) heeft voor dit element al een
        // laadbeslissing genomen. Wanneer wij daarna src/srcset zetten, haalt
        // de browser de bron niet alsnog op: currentSrc blijft leeg en het
        // beeld laadt nooit. Het attribuut verwijderen voor we de bron zetten
        // geeft de assignment terug aan de gewone (eager) laadstroom.
        lazyImage.removeAttribute("loading");
        lazyImage.src = lazyImage.dataset.src;
        if (lazyImage.dataset.srcset) {
            lazyImage.srcset = lazyImage.dataset.srcset;
        }
        // sizes hoort bij srcset: het lazy-filter (Settings.php) verplaatst
        // ook sizes naar data-sizes. Zonder herstel kiest de browser bij een
        // width-descriptor-srcset geen bron (currentSrc blijft leeg).
        // Het "auto"-keyword (WordPress 6.7+) werkt alleen samen met
        // loading="lazy"; dat ontbreekt hier, dus strip een leidend "auto"
        // zodat de resterende descriptor geldig blijft.
        if (lazyImage.dataset.sizes) {
            lazyImage.sizes = lazyImage.dataset.sizes.replace(
                /^\s*auto\s*,\s*/i,
                "",
            );
        }
        lazyImage.classList.add("loaded");
    };

    // Fallback: als IntersectionObserver ontbreekt, alles direct laden.
    if (!("IntersectionObserver" in window)) {
        lazyImages.forEach(loadImage);
        return;
    }

    let lazyImageObserver = new IntersectionObserver(
        function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    loadImage(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        },
        // Laad ruim voor de viewport zodat beelden op tijd binnen zijn en
        // trage/gemiste triggers voorkomen worden.
        { rootMargin: "200px 0px" },
    );

    lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
    });

    // Vangnet: sommige elementen (absoluut gepositioneerde object-fit-cover
    // achtergronden) worden door de observer nooit als intersecting gemeld en
    // blijven daardoor leeg. Na volledig laden van de pagina laden we elke
    // resterende lazy-image alsnog, zodat er geen lege beelden achterblijven.
    window.addEventListener("load", function () {
        document.querySelectorAll("img.lazy:not(.loaded)").forEach(function (
            lazyImage,
        ) {
            loadImage(lazyImage);
            lazyImageObserver.unobserve(lazyImage);
        });
    });
};

// WEBPACK FOOTER //
// ./src/js/modules/LazyLoad.js
